import { useProductSummaryAvailable } from '../productsSummary/hooks/useProductSummaryAvailable';
import { Routes } from 'src/Routes.constants';
import { useTariffSummaryAvailable } from '../tariffSummary/hooks/useTariffSummaryAvailable';

export const useDefaultProductTabRoute = () => {
  const tariffSummaryAvailable = useTariffSummaryAvailable();
  const productsSummaryAvailable = useProductSummaryAvailable();

  if (tariffSummaryAvailable) {
    return Routes.tariffSummary;
  }

  if (productsSummaryAvailable) {
    return Routes.productSummary;
  }

  return Routes.productsSim;
};
